import { SubTopic } from 'services/api/topics';
import { IContent } from 'services/api/content';
import { IFeaturedData } from 'provider/FeaturedProvider/FeaturedProvider.interface';

export const getDocumentUrl = (document: SubTopic | IContent) => {
  const isMediaLink = document?.document_url?.includes('media:');
  const apiMetaDataLink =
    document?.media_metadata?.[
      String(document?.document_url?.replace('media:', ''))
    ]?.url_with_extension;
  return isMediaLink ? apiMetaDataLink : document?.document_url;
};

export const getVideoUrl = (data: IContent | undefined | null) => {
  const isMediaLink = data?.video_url?.includes('media:');

  const apiMetaDataLink =
    data?.media_metadata?.[String(data?.video_url?.replace('media:', ''))]
      ?.url_with_extension;

  return isMediaLink ? apiMetaDataLink : data?.video_url;
};

export const getFeaturedImageUrl = (data: IFeaturedData | IContent): string => {
  // For non-product content types, use standard image_url
  const contentType = 'content_type' in data ? data.content_type : undefined;
  if (contentType !== 'products') {
    return data.image_url || '';
  }

  // For products, implement fallback priority
  const featuredData = data as IFeaturedData;

  // Priority 1: Thumbnail (listing_image_url)
  if (featuredData.listing_image_url?.trim()) {
    return featuredData.listing_image_url;
  }

  // Priority 2: Top Image (review_image_url)
  if (featuredData.review_image_url?.trim()) {
    return featuredData.review_image_url;
  }

  // Priority 3: Bottom Image (image_url)
  if (data.image_url?.trim()) {
    return data.image_url;
  }

  // Priority 4: Empty string (component will show default/app icon)
  return '';
};
